import type { GraphRepository } from '../ports/graph-repository';
import type { MediaRepository } from '../ports/media-repository';
import type { GraphArchivePackage } from '../../types/archive';
import { validateGraphDocument, validateMediaManifest } from '../policies/archive/validate-archive';
export class ArchiveImportService {
  constructor(private graphRepository: GraphRepository, private mediaRepository: MediaRepository) {}
  async importArchive(pkg: GraphArchivePackage, options: { replaceConfirmed: boolean }): Promise<{ imported: boolean; warnings: string[]; configJson?: unknown }> {
    const manifestResult = validateMediaManifest(pkg.mediaManifest);
    if (!manifestResult.valid || !manifestResult.manifest) throw new Error(manifestResult.errors.join('; '));
    const validation = validateGraphDocument(pkg.graphJson, manifestResult.manifest);
    if (!validation.valid || !validation.graph) throw new Error(validation.errors.join('; '));
    const current = await this.graphRepository.load();
    if (current && current.nodes.length > 0 && !options.replaceConfirmed) return { imported: false, warnings: ['replace cancelled'], configJson: pkg.configJson };
    const previous = current;
    try {
      await this.mediaRepository.clear();
      for (const asset of manifestResult.manifest.assets) await this.mediaRepository.put({ metadata: asset, data: pkg.assets[asset.filename] ?? '' });
      await this.graphRepository.replace(validation.graph);
      return { imported: true, warnings: validation.warnings, configJson: pkg.configJson };
    } catch (error) {
      if (previous) await this.graphRepository.replace(previous);
      throw error;
    }
  }
}
